































































































































































































































































































































































import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { Auth, Logger } from "aws-amplify";
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import * as rules from '@/rules';
import { Urls } from "@/Urls";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import Navigation from "@/store/modules/Navigation";

const navigationModule = getModule(Navigation);

// Logger.LOG_LEVEL = "DEBUG";
const logger = new Logger("SignUp.vue");

@Component({
    components: {}
})

export default class SignUp extends Vue {

    @Prop({ type: Boolean, default: false })
    embed!: boolean;

    @Prop({ type: Boolean, default: false })
    autofill!: boolean;

    @Prop()
    error!: string;

    @Prop({ default: false, type: Boolean})
    isPopup!: boolean;

    @Ref()
    private formRef: HTMLFormElement;

    @Ref()
    private emailAddress: HTMLInputElement;

    private readonly Urls = Urls;
    private form: any = {};
    private showPassword = false;
    private emailErrorMessages: string | null = null;
    private submitting = false;
    private signUpSent = false;

    private rules = {
        required: rules.REQUIRED,
        passwordRequirements: rules.PASSWORD_STRENGTH,
        passwordMatch: (v: string) => !!v && v == this.form.password || 'Passwords do not match.',
        emailFormat: rules.EMAIL_FORMAT,
        phoneFormat: rules.PHONE_FORMAT,
    }

    mounted() {
        // TODO (Dion - 2021-06-09) - We need to place this
        // as an async function right on the email input field
        if (this.error && this.error.includes('DUPLICATE_EMAIL')) {
            this.emailErrorMessages = "An account with this email already exists";
        }
        const emailAddressRef = this.emailAddress;
        emailAddressRef.focus();
        // setTimeout( ()=>( emailAddressRef.focus(), 200) );
    }

    private socialSignIn(provider: CognitoHostedUIIdentityProvider) {
        Auth.federatedSignIn({provider: provider})
    }

    private async createAccount() {
        if (!this.formRef.validate()) {
            return;
        }

        try {
            // const phone: string = '+1' + this.form.phone.replace(/\D/g, '');
            this.submitting = true;
            console.log('Auth.signUp()');
            let unauthUser: any;
            let authUser = await Auth.currentUserInfo();
            let unauthUserId: string;
            if (!authUser) {
                if(this.isPopup) {
                    Vue.$cookies.set('signup-marketplace', '/marketplace')
                }
                unauthUser = await Auth.currentCredentials();
                unauthUserId = unauthUser.identityId;
            }
            console.log('unauthUserId');
            console.log(unauthUserId);
            const signUpResult = await Auth.signUp({
                username: this.form.email.toLowerCase(),
                password: this.form.password,
                attributes: {
                    email: this.form.email.toLowerCase(),
                    profile: unauthUserId //,
                    // phone_number: this.form.phone,
                    // name: this.form.name,
                    // given_name: this.form.name,
                    // family_name: this.form.last
                }
            });
            if (signUpResult) {
                this.signUpSent = true;
                console.log('signUpResult');
                console.log(signUpResult);
                if (signUpResult.userConfirmed) {
                    console.log('userConfirmed');
                    await this.$router.push(Urls.LOGIN);
                } else {
                    // let unauthUser: any;
                    // let authUser = await Auth.currentUserInfo();
                    // let unauthUserId: string;
                    // if (!authUser) {
                    //     unauthUser = await Auth.currentCredentials();
                    //     unauthUserId = unauthUser.identityId;
                    //     navigationModule.setAnonUserId(unauthUserId);
                    //     let res: any = await VIEWPOINT_API.updateOwnership(unauthUserId, signUpResult.userSub);
                    //     console.log('VIEWPOINT_API.updateOwnership(unauthUserId, signUpResult.userSub)');
                    //     console.log(res);
                    // }
                    // console.log('unauthUserId');
                    // console.log(unauthUserId);
                }
            }
        } catch (e) {
            if (e.code === 'UsernameExistsException') {
                this.emailErrorMessages = "An account with this email already exists";
            }
            console.log(e);
        }
        this.submitting = false;
    }

    private async resendConfirmation() {
        this.submitting = true;
        await Auth.resendSignUp(this.form.email);
        this.submitting = false;
    }

}
